export const largeOrgThreshold = 750;

export const orgTypeString: { [key: string]: string } = {
  school: 'School',
  district: 'District',
  other: 'Organization',
};

export const baseTrackingPrefix = 'admin_self_serve.v2';
